const isDev = process.env.NODE_ENV === "development";

export const clientApiBaseUrl = isDev
  ? "https://localhost:44314/api"
  : "https://auditsapi.riteliberia.org/api";

export const userApiBaseUrl = isDev
  ? "https://localhost:44313/api"
  : "https://usersapi.riteliberia.org/api";
